/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Coach_Source_NInputs */

const en_us2_coach_source_n = /** @type {(inputs: Coach_Source_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Source ${i?.n}`)
};

const pt_br2_coach_source_n = /** @type {(inputs: Coach_Source_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fonte ${i?.n}`)
};

const es_419_coach_source_n = /** @type {(inputs: Coach_Source_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fuente ${i?.n}`)
};

const pt_pt2_coach_source_n = /** @type {(inputs: Coach_Source_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fonte ${i?.n}`)
};

const fr_fr2_coach_source_n = /** @type {(inputs: Coach_Source_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Source ${i?.n}`)
};

const de_de2_coach_source_n = /** @type {(inputs: Coach_Source_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Quelle ${i?.n}`)
};

const it_it2_coach_source_n = /** @type {(inputs: Coach_Source_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fonte ${i?.n}`)
};

/**
* | output |
* | --- |
* | "Source {n}" |
*
* @param {Coach_Source_NInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_source_n = /** @type {((inputs: Coach_Source_NInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Source_NInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_source_n(inputs)
	if (locale === "es-419") return es_419_coach_source_n(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_source_n(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_source_n(inputs)
	if (locale === "de-DE") return de_de2_coach_source_n(inputs)
	if (locale === "it-IT") return it_it2_coach_source_n(inputs)
	return en_us2_coach_source_n(inputs)
});
export { coach_source_n as "coach.source_n" }